import React from 'react';
import { 
  Car, 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  Linkedin, 
  Instagram, 
  Youtube,
  Shield,
  Award,
  Clock,
  Heart
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import FooterImage from "../Assets/Untitled-9999991.png"

const Footer = ({ onNavigate }) => {
  const navigate = useNavigate();

  const navItems = [
    { id: 'home', label: 'Home', path: '/' },
    { id: 'vehicles', label: 'Our Fleet', path: '/vehicles' },
    { id: 'about', label: 'About Us', path: '/about' },
    { id: 'contact', label: 'Contact', path: '/contact' }
  ];

  const services = [
    { id: 'services', label: 'Airport Transfers', path: '/about' },
    { id: 'services', label: 'City Rides', path: '/about' },
    { id: 'services', label: 'Outstation Trips', path: '/about' },
    { id: 'services', label: 'Corporate Travel', path: '/about' },
    { id: 'services', label: 'Wedding Services', path: '/about' },
    { id: 'services', label: 'Hourly Rentals', path: '/about' }
  ];

  const features = [
    { icon: Shield, text: 'Safe & Secure Rides' },
    { icon: Award, text: 'Premium Quality' },
    { icon: Clock, text: '24/7 Service' }
  ];

  const handleNavigation = (path, serviceName = '') => {
    if (path) {
      // Use React Router navigation
      navigate(path);
      
      // Also call the original onNavigate callback if provided
      if (onNavigate) {
        onNavigate(path, { service: serviceName });
      }
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-900 to-gray-900 text-white relative overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <div className="flex items-center mb-6">
                <div className="relative">
                  {/* <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center transform rotate-45 mr-3">
                    <Car className="text-white transform -rotate-45" size={24} />
                  </div> */}
                </div>
                <div>
                  <span className="text-2xl font-bold bg-gradient-to-r from-gray-100 to-gray-100 bg-clip-text text-transparent">
                    My Journey Cabs
                  </span>
                  <p className="text-sm text-blue-300">Premium Rides, Anytime</p>
                </div>
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Experience luxury and reliability with our premium cab services. 
                Your journey, our responsibility - safe, comfortable, and on time.
              </p>
              
              {/* Trust Features */}
              <div className="space-y-3">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center">
                      <feature.icon className="h-4 w-4 text-blue-400" />
                    </div>
                    <span className="text-sm text-gray-300">{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                Quick Links
                <div className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-blue-500"></div>
              </h3>
              <div className="space-y-3">
                {navItems.map(item => (
                  <button
                    key={item.id}
                    onClick={() => handleNavigation(item.path)}
                    className="block w-full text-left text-gray-300 hover:text-blue-400 transition-all duration-300 hover:translate-x-2 hover:bg-white/5 rounded-lg px-3 py-2"
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                Our Services
                <div className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-green-500"></div>
              </h3>
              <div className="space-y-3">
                {services.map((service, index) => (
                  <button
                    key={index}
                    onClick={() => handleNavigation(service.path, service.label)}
                    className="block w-full text-left text-gray-300 hover:text-green-400 transition-all duration-300 hover:translate-x-2 hover:bg-white/5 rounded-lg px-3 py-2 group"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-1.5 h-1.5 bg-green-500 rounded-full group-hover:scale-125 transition-transform"></div>
                      <span className="text-sm">{service.label}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Contact & Newsletter */}
            <div>
              <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                Stay Connected
                <div className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-cyan-500"></div>
              </h3>
              
              {/* Contact Info */}
              <div className="space-y-4 mb-6">
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center group-hover:bg-cyan-500 transition-colors">
                    <Phone className="h-4 w-4 text-cyan-400 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Call Us</p>
                    <p className="text-white font-semibold">+91 9728115781 <br/> +91 9467855781</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center group-hover:bg-blue-500 transition-colors">
                    <Mail className="h-4 w-4 text-blue-400 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Email Us</p>
                    <p className="text-white font-semibold">myjourneycabs@gmail.com</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3 group">
                  <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center group-hover:bg-green-500 transition-colors">
                    <MapPin className="h-4 w-4 text-green-400 group-hover:text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-400">Location</p>
                    <p className="text-white font-semibold">Delhi | Bangalore | Bhubaneswar | Mumbai | Chennai | Kolkata | Goa
</p>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              <div className="flex space-x-3 mb-6">
                {[
                  { 
                    icon: Facebook, 
                    color: 'blue-500', 
                    hover: 'blue-600',
                    url: 'https://www.facebook.com/profile.php?id=100067590563390' 
                  },
                  { 
                    icon: Linkedin, 
                    color: 'sky-500', 
                    hover: 'sky-600',
                    url: 'https://www.linkedin.com/in/my-journey-cabs-ride-beyond-discover-within-8777b5249?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' 
                  },
                  { 
                    icon: Instagram, 
                    color: 'pink-500', 
                    hover: 'pink-600',
                    url: 'https://www.instagram.com/myjourneycabs?igsh=Y2QxeXJvNDczcnZh' 
                  },
                  { 
                    icon: Youtube, 
                    color: 'red-500', 
                    hover: 'red-600',
                    url: 'https://www.youtube.com/' 
                  }
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 bg-${social.color}/20 rounded-lg flex items-center justify-center hover:bg-${social.color} transition-all duration-300 transform hover:scale-110 hover:shadow-lg`}
                  >
                    <social.icon className={`h-4 w-4 text-${social.color} hover:text-white`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
     {/* Complete Bottom Bar with Logo Credit */}
<div className="border-t border-blue-800/50 py-8">
  <div className="flex flex-col md:flex-row items-center justify-between">
    <div className="flex flex-col md:flex-row items-center space-y-3 md:space-y-0 md:space-x-8 mb-6 md:mb-0">
      {/* Copyright */}
      <span className="text-sm text-gray-400">
        © 2025-2026 MyJourney Cab. All rights reserved.
      </span>
      
      {/* Developer Credit with Logo */}
      <a 
        href="https://techtota.com" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center space-x-2 text-sm text-gray-400 hover:text-white transition-colors group"
      >
        <div className="  flex items-center justify-center">
          {/* Your Logo/Initial */}
          <div className="w-8 h-8 rounded-lg overflow-hidden bg-white/10 p-1">
  <img 
    src={FooterImage} 
    alt="Techtota" 
    className="h-7 w-7 object-contain"
  />
</div>
          {/* <span className="text-xs font-bold text-white">Y</span> */}
        </div>
        <span>
          Developed by <span className="font-medium text-blue-400 group-hover:text-blue-300">TechTota</span>
        </span>
      </a>
    </div>
    
    {/* Policy Links */}
    <div className="flex flex-wrap items-center justify-center space-x-6 text-sm text-gray-400">
      <button 
        onClick={() => handleNavigation('/privacy')}
        className="hover:text-blue-400 transition-colors"
      >
        Privacy Policy
      </button>
      <button 
        onClick={() => handleNavigation('/terms')}
        className="hover:text-blue-400 transition-colors"
      >
        Terms of Service
      </button>
      <button 
        onClick={() => handleNavigation('/cookies')}
        className="hover:text-blue-400 transition-colors"
      >
        Cookie Policy
      </button>
    </div>
  </div>
</div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-10 right-10 w-20 h-20 bg-blue-500/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 left-10 w-16 h-16 bg-cyan-500/10 rounded-full blur-xl"></div>
    </footer>
  );
};

export default Footer;